import Service from "./Service";

class AccountApiService extends Service {
  constructor() {
    super("api");
  }

  async getAll(payload) {
    let result = await this.post(`Administration/GetAccounts`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async deleteByUserName(userName) {
    let result = await this.delete(`Administration/DeleteAccounts/${userName}`, (status, data) => {
      return data;
    });
    return result;
  }

  async addAccount(payload) {
    let result = await this.post(`Administration/AddAccount`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async toggleAccountBlocking(payload) {
    let result = await this.post(`Administration/ToggleAccountBlocking`, payload, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new AccountApiService();
